/* unplugin-vue-components disabled */import { render } from "./HomeView.vue?vue&type=template&id=0e0b9123&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=0e0b9123&lang=scss&scoped=true"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0b9123"]])

export default __exports__